import React, { useEffect } from 'react';
import { ArrowLeft, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';
import '../styles/booking-embed.css';

const ConsultPage = () => {
  useEffect(() => {
    // Load Acuity embed script
    const script = document.createElement('script');
    script.src = 'https://embed.acuityscheduling.com/js/embed.js';
    script.type = 'text/javascript';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script on unmount
      const existingScript = document.querySelector('script[src="https://embed.acuityscheduling.com/js/embed.js"]');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <div className="booking-embed-page consult-page">
      <div className="booking-embed-header consult-header">
        <Link to="/consulting" className="back-link">
          <ArrowLeft size={20} />
          Back to Start Here
        </Link>
        <h1 className="booking-embed-title consult-headline">
          You're able. You just can't seem to do it consistently.
        </h1>
        
        <div className="consult-copy">
          <p className="consult-paragraph accent-paragraph">
            You're not lazy. You're not broken. You're not behind.
          </p>
          
          <p className="consult-paragraph">
            You're busy, you're capable, and somewhere between knowing what to do and actually doing it — something keeps dropping.
          </p>
          
          <p className="consult-paragraph">
            This session is for the person who's done overthinking and ready to pick one thing and move.
          </p>
          
          <h2 className="consult-section-header">Here's what happens in 50 minutes:</h2>
          
          <p className="consult-paragraph">
            With permission from bestselling author Sahil Bloom, we use his 5 Types of Wealth framework — physical, mental, financial, social, time — to find where you're actually leaking energy. Then we look at what you already have available and build one honest 30-day plan around that one thing.
          </p>
          
          <p className="consult-paragraph">
            No new programs. No homework before we talk. Just show up.
          </p>
          
          <p className="consult-paragraph closing-paragraph">
            You leave with clarity, a plan, and one thing to do next.
          </p>
          
          <p className="consult-detail-line">
            $97 · 50 minutes · Zoom · With Cal
          </p>
          
          <p className="consult-cta-text">Book your session</p>
        </div>
      </div>

      <div className="booking-embed-container" data-testid="acuity-embed-container">
        <iframe 
          src="https://app.acuityscheduling.com/schedule.php?owner=37343334&appointmentType=85018998&ref=embedded_csp" 
          title="Schedule 1:1 Personal Operations Session" 
          width="100%" 
          height="800" 
          frameBorder="0" 
          allow="payment"
          className="booking-embed-iframe acuity-iframe"
        />
      </div>

      <div className="booking-embed-fallback">
        <p>Having trouble?</p>
        <a 
          href="https://app.acuityscheduling.com/schedule.php?owner=37343334&appointmentType=85018998" 
          target="_blank" 
          rel="noopener noreferrer"
          className="fallback-link"
        >
          Open booking page in a new tab
          <ExternalLink size={16} />
        </a>
      </div>
    </div>
  );
};

export default ConsultPage;
